export const BASE_API_URL = 'communications/api/v1/'
